import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/index";
import router from "./router";
import "./plugins/base";
import "./plugins/chartist";
import "./plugins/vee-validate";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "./bootstrap";
import Index from "./App";
import "./scaffoldings";
import Notification from "./helpers/Notification";
import "./sass/_generic.scss";
import * as FilePond from "filepond";

FilePond.setOptions({
	server: {
		url: "/api",
		process: {
			url: "/media",
			method: "POST",
			withCredentials: false,
			headers: {
				"X-CSRF-TOKEN": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content"),
			},
		},
	},
});

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(Notification);
store.dispatch("auth/get").finally(() => {
	new Vue({
		store,
		vuetify,
		i18n,
		render: h => h(Index),
		router,
	}).$mount("#app");
});
